import React from 'react';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import DownArrow from '@material-ui/icons/ArrowDropDown';
import UpArrow from '@material-ui/icons/ArrowDropUp';
import moment from 'moment';
import { HorizontalBar } from 'react-chartjs-2';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import ArrowSlider from '../../../components/ArrowSlider';
import { useSelector } from 'react-redux';
import SharkIcon from '../../icons/shark.png';

const OIChartModal = ({
  styles,
  handleCloseChart,
  state,
  lengthCheck,
  setState,
  removeDate,
  modalRef,
  dataCall,
  barOptionsCalls,
  dataPut,
  barOptionsPuts,
  barOptionsCallsBottom,
  barOptionsPutsBottom,
}) => {
  const appReducer = useSelector((state) => state.appReducer);
  const { quoteInfo } = appReducer;
  const { latestPrice, change, changePercent, symbol } = quoteInfo;
  const priceChange = change;
  const priceChangePercent = changePercent;

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={state.showChart}
      onClose={() => handleCloseChart()}
    >
      <div
        style={
          !appReducer.isMobile ? styles.modalChart : styles.modalChartMobile
        }
      >
        <div
          style={
            !appReducer.isMobile ? styles.modalheader : styles.modalheaderMobile
          }
        >
          <div
            onClick={() => handleCloseChart()}
            style={styles.modalCloseButton}
          >
            X
          </div>

          <div
            style={{
              fontSize: appReducer.isMobile ? '20px' : '24px',
              fontWeight: 'bold',
              padding: '25px 5% 0px 5%',
            }}
          >
            Open Interest
          </div>
          <div
            style={
              !appReducer.isMobile ? styles.modalinfo : styles.modalinfoMobile
            }
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              {symbol && (
                <Typography
                  variant="inherit"
                  component="h3"
                  style={
                    !appReducer.isMobile
                      ? styles.companyText
                      : styles.companyTextMobile
                  }
                >
                  {appReducer.quoteInfo.companyName && !appReducer.isMobile
                    ? appReducer.quoteInfo.companyName.substring(0, 12)
                    : ''}{' '}
                  {!appReducer.isMobile
                    ? `(${symbol})`
                    : `${symbol} $${(latestPrice * 1).toFixed(2)}
                                      `}
                </Typography>
              )}
              {symbol && (
                <div
                  style={{
                    ...styles.stockPriceInfo,
                    paddingLeft: !appReducer.isMobile ? '20px' : '5px',
                  }}
                >
                  {!appReducer.isMobile && (
                    <span
                      style={
                        appReducer.isMobile
                          ? styles.stockPriceMobile
                          : styles.stockPrice
                      }
                    >
                      ${(latestPrice * 1).toFixed(2)}
                    </span>
                  )}
                  <span
                    style={
                      priceChange < 0
                        ? styles.negPriceChange
                        : styles.posPriceChange
                    }
                  >
                    {priceChange < 0 ? (
                      <DownArrow
                        style={
                          appReducer.isMobile
                            ? styles.downArrowMobile
                            : styles.downArrow
                        }
                      />
                    ) : (
                      <UpArrow
                        style={
                          appReducer.isMobile
                            ? styles.upArrowMobile
                            : styles.upArrow
                        }
                      />
                    )}{' '}
                    <span style={styles.priceChange}>
                      ${Math.abs(priceChange).toFixed(2)}
                    </span>
                    ({Math.abs(priceChangePercent * 100).toFixed(2)}
                    %)
                  </span>
                </div>
              )}
            </div>
            {symbol && (
              <div style={{ display: 'flex' }}>
                <Typography
                  variant="body1"
                  component="div"
                  style={{
                    fontSize: !appReducer.isMobile ? '15px' : '12px',
                  }}
                >
                  As of{' '}
                  {/* <span>{moment(quoteInfo.latestTime).format("MMM DD")}</span> <span>4:00pm</span> */}
                  {moment(appReducer.quoteInfo.latestUpdate).format(
                    'MMM DD h:mma'
                  )}
                </Typography>

                {lengthCheck ? (
                  <div
                    style={{
                      height: '20px',
                      width: '20px',
                      marginLeft: '10px',
                    }}
                    onClick={() => setState({ holderModal: true })}
                  >
                    <img height="100%" width="100%" src={SharkIcon} alt="" />
                  </div>
                ) : (
                  ''
                )}
              </div>
            )}
          </div>
          <div style={styles.datelist}>
            <div style={{ display: 'inline-flex' }}>
              {state.dates.map((date, index) => (
                <div
                  style={
                    !appReducer.isMobile
                      ? styles.dateitem
                      : styles.dateitemmobile
                  }
                  key={index}
                >
                  {moment(date).format('DD-MMM-YY')}
                  <span
                    onClick={() => removeDate(index)}
                    style={styles.dateclose}
                  >
                    x
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div
            style={{
              padding: '5px',
              background: 'black',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
              position: 'absolute',
              bottom: '0px',
              width: '95%',
              left: '2.5%',
              margin: 'auto',
              boxSizing: 'border-box',
            }}
          >
            <div
              style={{
                color: 'white',
                fontSize: appReducer.isMobile ? '16px' : '20px',
                fontWeight: 'bold',
              }}
            >
              Calls
            </div>
            <div
              style={{
                color: 'white',
                fontSize: appReducer.isMobile ? '16px' : '20px',
                fontWeight: 'bold',
              }}
            >
              Puts
            </div>
          </div>
        </div>

        <div
          style={
            !appReducer.isMobile
              ? styles.modalchartscr
              : styles.modalchartscrMobile
          }
          ref={modalRef}
        >
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div
              style={{
                width: !appReducer.isMobile
                  ? 'calc(50% - 32px)'
                  : 'calc(50% - 28px)',
                height: state.modalStrikes.length * 20 + 9 + 'px',
              }}
            >
              <HorizontalBar
                data={dataCall}
                options={barOptionsCalls}
                redraw={true}
              />
            </div>
            <div
              style={{
                width: !appReducer.isMobile ? '63px' : '55px',
                height: state.modalStrikes.length * 20 + 'px',
              }}
            >
              <div style={styles.currentPriceArrowsContainerModal}>
                <ArrowSlider
                  height={0}
                  arrowPos={0}
                  yStartingPosition={state.arrowPositionModal}
                  rowHeight={20}
                  strikeArrow
                  basicStrike
                  isMobile={appReducer.isMobile}
                  side={'left'}
                />
                <ArrowSlider
                  height={0}
                  arrowPos={0}
                  rowHeight={20}
                  yStartingPosition={state.arrowPositionModal}
                  strikeArrow
                  basicStrike
                  isMobile={appReducer.isMobile}
                  side={'right'}
                />
              </div>

              <Table
                stickyHeader
                style={{
                  height: '100%',
                  width: !appReducer.isMobile ? '63px' : '55px',
                  overflowY: 'hidden',
                }}
              >
                <TableBody>
                  {state.modalStrikes.map((row, rowindex) => (
                    <TableRow key={rowindex} style={{ height: '20px' }}>
                      <TableCell
                        style={{
                          ...(!appReducer.isMobile
                            ? styles.strikecell
                            : styles.strikecellMobile),
                          padding: '0px',
                        }}
                      >
                        {parseFloat(row).toFixed(2)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
            <div
              style={{
                marginLeft: '-10px',
                width: !appReducer.isMobile
                  ? 'calc(50% - 32px)'
                  : 'calc(50% - 28px)',
                height: state.modalStrikes.length * 20 + 9 + 'px',
              }}
            >
              <HorizontalBar
                data={dataPut}
                options={barOptionsPuts}
                redraw={true}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            position: 'absolute',
            bottom: '0px',
            left: '2.5%',
            width: '95%',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div
              style={{
                width: !appReducer.isMobile
                  ? 'calc(50% - 32px)'
                  : 'calc(50% - 28px)',
                height: '50px',
              }}
            >
              <HorizontalBar
                data={dataCall}
                options={barOptionsCallsBottom}
                redraw={true}
              />
            </div>
            <div style={{ width: '63px' }}></div>
            <div
              style={{
                marginLeft: '-10px',
                width: !appReducer.isMobile
                  ? 'calc(50% - 32px)'
                  : 'calc(50% - 28px)',
                height: '50px',
              }}
            >
              <HorizontalBar
                data={dataPut}
                options={barOptionsPutsBottom}
                redraw={true}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            position: 'absolute',
            width: '96%',
            left: '2%',
            height: '50px',
            bottom: '-22px',
            background: 'white',
          }}
        ></div>
      </div>
    </Modal>
  );
};
export default OIChartModal;



// WEBPACK FOOTER //
// ./src/Pages/OpenInterest/components/OIChartModal.jsx